<template>
  <div :class="mobileMenu ? 'enable-vertical-menu' : ''">
    <div id="layout-wrapper">
      <div class="vertical-menu mm-active">
        <div class="h-100" :class="theme == 'dark' ? 'dark' : ''">
          <div class="navbar-brand-box">
            <img :src="require(`../../assets/images/logo-${theme}.png`)" />
          </div>

          <div id="sidebar-menu">
            <Menu :theme="theme" :open-names="openItem" :active-name="activeName" accordion>
              <div v-for="item in menuItem" :key="item.path">
                <MenuItem v-show="!item.isFold" :name="item.name" :to="item.path">
                <span :class="item.icon"></span>
                {{ item.text }}
                </MenuItem>

                <Submenu v-show="item.isFold" :name="item.name">
                  <template slot="title">
                    <span :class="item.icon"></span>
                    {{ item.text }}
                  </template>
                  <MenuItem v-for="list in item.children" :key="list.path" :name="list.name" :to="list.path">
                  {{ list.text }}
                  </MenuItem>
                </Submenu>
              </div>
            </Menu>
          </div>
        </div>
      </div>

      <header id="page-topbar">
        <div class="navbar-header fixed-header">
          <div class="d-flex align-items-left">
            <span class="iconfont icon-caidan menu" @click="mobileMenu = !mobileMenu"></span>
            <span class="iconfont full" :class="isFullscreen ? 'icon-suoxiao' : 'icon-quanping'"
              @click="screenfull"></span>
          </div>

          <div class="d-flex align-items-center">
            <div class="dropdown d-inline-block">
              <!-- <span class="badge-got"></span> -->
              <Icon type="ios-notifications-outline" size="26" @click="msg"></Icon>
            </div>
            <div class="dropdown d-inline-block" v-if="$store.state.auth == 1">
              <Icon custom="iconfont icon-shanghuguanli1" size="26" @click="modal = true"></Icon>
            </div>

            <div class="dropdown d-inline-block">
              <Dropdown trigger="click">
                <a href="javascript:void(0)">
                  <img :src="require('../../assets/img/default_handsome.jpg')" class="avatar" alt="" />
                </a>
                <DropdownMenu slot="list">
                  <DropdownItem>
                    <div @click="$router.push('/admin/setting-user')" class="right-btn">
                      <span class="iconfont icon-gerenxinxi"></span>
                      个人信息
                    </div>
                  </DropdownItem>
                  <DropdownItem>
                    <div @click="$router.push('/admin/setting-log')" class="right-btn">
                      <span class="iconfont icon-wj-rz"></span>
                      操作日志
                    </div>
                  </DropdownItem>
                  <DropdownItem>
                    <div @click="exit">
                      <span class="iconfont icon-zhuxiaodenglu"></span>
                      退出登录
                    </div>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
          </div>
        </div>
      </header>

      <div class="main-content">
        <router-view></router-view>

        <footer class="footer">
          <div class="container-fluid">
            <div class="footer-left">Geek-AUTH</div>
            <div class="footer-right">© 极客实验室</div>
          </div>
        </footer>
      </div>
    </div>
    <Modal v-model="modal" title="添加授权商" @on-ok="ok">
      <Input v-model="createData.phone" placeholder="请输入手机号" prefix="ios-lock-outline"></Input>
    </Modal>
    <div class="menu-overlay" @click="mobileMenu = !mobileMenu"></div>
  </div>
</template>

<script>
  import menuItem from "./data";
  import {
    postUser
  } from "@/api"
  export default {
    data() {
      return {
        theme: "dark", //dark  light
        menuItem: [],
        activeName: "",
        openItem: [],
        mobileMenu: false,
        isFullscreen: false,
        isScrollTop: true,
        modal: false,
        createData: {
          phone: "",
        }
      };
    },

    methods: {
      // 消息
      msg() {
        this.$Message.info({
          background: true,
          content: "暂无新消息",
        });
      },
      ok() {
        postUser({
          phone: this.createData.phone
        }).then(res => {
          if (res.code == 200) {
            this.$Message.success({
              background: true,
              content: res.msg,
            });
          } else {
            this.$Message.error({
              background: true,
              content: res.msg,
            });
          }
        })

      },
      // 退出登录
      exit() {
        this.$Modal.confirm({
          title: "退出确认",
          content: "即将退出登录，是否继续？",
          onOk: () => {
            sessionStorage.removeItem("token", true);
            this.$router.push("/login");
          },
        });
      },
      // 全屏/缩小
      screenfull() {
        if (this.isFullscreen) {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
          }
          this.isFullscreen = false;
        } else {
          let docElm = document.documentElement;
          if (docElm.requestFullscreen) {
            docElm.requestFullscreen();
          } else if (docElm.msRequestFullscreen) {
            docElm.msRequestFullscreen();
          } else if (docElm.mozRequestFullScreen) {
            docElm.mozRequestFullScreen();
          } else if (docElm.webkitRequestFullScreen) {
            docElm.webkitRequestFullScreen();
          }
          this.isFullscreen = true;
        }
      },
      // 导航
      navigates() {
        this.menuItem = menuItem;
        this.activeName = this.$route.name;
        if (this.$route.name.indexOf("-") != -1) {
          this.openItem.push(this.$route.name.split("-")[0]);
        }
      },
    },
    created() {
      this.navigates();
    },
    watch: {
      // 监听路由刷新
      $route: {
        handler: function (val, oldVal) {
          this.mobileMenu = false
        },
        // 深度观察监听
        deep: true,
      },
    },
  };
</script>

<style lang="less" scoped>
  @import url("../../assets/css/theme.min.css");
  @import url("../../assets/css/clean.css");
  @deep: ~">>>";

  @{deep}.ivu-dropdown,
  .ivu-icon {
    vertical-align: middle;
  }



  .align-items-left {
    width: 100%;
    height: 60px;
    // padding: 0 20px;
    text-align: center;
    line-height: 60px;

    span {
      width: 60px;
      font-size: 20px;
      vertical-align: middle;
    }
  }

  .badge-got {
    position: absolute;
    transform: translateX(-50%);
    transform-origin: 0 center;
    top: 12px;
    right: 5px;
    height: 8px;
    width: 8px;
    border-radius: 100%;
    background: #ed4014;
    z-index: 10;
    box-shadow: 0 0 0 1px #fff;
  }

  .navbar-brand-box {
    width: 240px;
    height: 120px;

    img {
      margin: 0 auto;
      width: 120px;
      height: 120px;
    }
  }

  .right-btn .iconfont {
    vertical-align: middle;
  }

  .h-100 {
    height: 100vh;
  }

  @{deep}.ivu-menu-light:after {
    width: 0;
  }

  @{deep}.ivu-form-item-label {
    font-weight: 100;
    font-size: 14px;
  }
</style>